import {CommonModule} from '@angular/common';
import {Component, computed, input, output} from '@angular/core';
import {MatExpansionPanel, MatExpansionPanelHeader} from '@angular/material/expansion';
import {RouterLink, RouterLinkActive} from '@angular/router';
import {CovIconComponent} from '@cov/ui-angular';
import {FloatingMenuComponent} from '../floating-menu/floating-menu.component';
import {SubNavigationItemComponent} from '../sub-navigation-item/sub-navigation-item.component';
import {NavigationItem} from '../types/navigation.types';

@Component({
  selector: 'cov-main-navigation-item',
  imports: [
    CommonModule,
    RouterLink,
    RouterLinkActive,
    CovIconComponent,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    SubNavigationItemComponent,
    FloatingMenuComponent,
  ],
  templateUrl: './main-navigation-item.component.html',
  styleUrl: './main-navigation-item.component.scss',
})
export class MainNavigationItemComponent {
  // INPUT
  // currently rendered navigation item
  public navItem = input.required<NavigationItem>();
  public activeFloatingMenuNavItem = input<NavigationItem | null>(null);
  // tablet / size limited view of the navigation
  public useOverlay = input<boolean>(false);
  // if this nav item has children and is expanded
  public itemGroupExpanded = input<boolean>(false);
  // floating menu items
  public navItemActivated = output<void>();
  public navItemContainerOpened = output<NavigationItem>();

  // STATE
  public isActiveFloatingMenuItem = computed(() => {
    const activeItem = this.activeFloatingMenuNavItem();
    return activeItem === this.navItem();
  });
  public isFloatingMenuActive = computed(
    () => this.useOverlay() && this.isActiveFloatingMenuItem(),
  );
  public activateNavItem(event: Event) {
    event.stopPropagation();
    this.navItemActivated.emit();
  }
}
